import * as path from "path";

import { copy, pathExists, readFile } from "fs-extra";

import { ILogger } from "../../Commons/Logging/ILogger";
import { getLogger } from "../../Commons/Logging/StaticLogger";
import { BuildCache, FormBuildCacheOptions } from "../../FormWebpackConfiguration/CacheAssetsPlugin";
import { BuildCacheMode } from "../../CLICommands/BuildForms/BuildCacheMode";

export async function writeResourceFile(
    loggerPrefix: string,
    sourceFileFormRelatedName: string,
    targetFileResourceRelativeName: string,
    gfv: string,
    formDirectory: string,
    resourcesDirectory: string,
    parentLogger: ILogger = getLogger(),
    buildCache?: BuildCache,
    buildCacheOptions?: FormBuildCacheOptions,
    buildCacheExist?: boolean
): Promise<void> {
    const logger = parentLogger.withPrefix(`${loggerPrefix}:${gfv}`);
    const sourceFile = path.join(formDirectory, "form", sourceFileFormRelatedName);
    const targetFile = path.join(resourcesDirectory, targetFileResourceRelativeName);
    const sourceFileExists = await pathExists(sourceFile);
    const targetFileExists = await pathExists(targetFile);

    if (sourceFileExists) {
        if (!targetFileExists || !buildCacheExist) {
            logger.log(`copy\n  from: ${sourceFile}\n  to: ${targetFile}`);
            await copy(sourceFile, targetFile);
        }

        if (
            buildCache != undefined &&
            buildCacheOptions != undefined &&
            (buildCacheOptions.mode === BuildCacheMode.ForceUpdate ||
                buildCacheOptions.mode === BuildCacheMode.UpdateIfNeed)
        ) {
            await buildCache.setContent(
                buildCacheOptions.generatorVersion,
                buildCacheOptions.gfv,
                buildCacheOptions.depsHash,
                targetFileResourceRelativeName,
                await readFile(sourceFile, "utf-8")
            );
        }
    }
}
